export default {
  init() {
  },
  finalize() {

    function fluidCourse(){
      $('.grassblade_iframe').each(function(){
        var contents = $(this).contents();
        $('<style class="testy">.lesson__content{max-height: none;}.page__wrapper{min-height: auto;}.previous-lesson,.next-lesson{display:none !important;}</style>').appendTo(contents.find('head'));
      });
    }

    function loopIframes(){
        $('.grassblade_iframe').each(function(){
          var iframe_height = 0;
          var iframe_height_header = $(this).contents().find('body header');
          var iframe_height_main = $(this).contents().find('body main > div');

          // $(this).height(iframe_height);

          if( iframe_height_header && iframe_height_header.height() > 0 ) {
            iframe_height = iframe_height + iframe_height_header.height();
          } else {
            console.log('iframe_height_header NOT detected');
          }

          if( iframe_height_main && iframe_height_main.height() > 0 ) {
            iframe_height = iframe_height + iframe_height_main.height();
          } else {
            console.log('iframe_height_main NOT detected');
          }

          if( iframe_height <= $(window).height() ) {
            iframe_height = $(window).height();
            $(this).attr('scrolling', 'auto');

            console.log('Unable to detect iframe HTML so defaulting to the size of the screen has a fallback.');
          } else {
            $(this).attr('scrolling', 'no');
          }

          $(this).height(iframe_height);
          console.log('iframe resized: '+iframe_height);
        });
    }
    // setInterval(function(){
    //   loopIframes();
    //   fluidCourse();
    // }, 250);

    var x = 0;
    var intervalID = setInterval(function () {

      loopIframes();
      fluidCourse();

      if (++x === 50) {
         if( $('.grassblade_iframe').height() <= 1000 ) {
           $('.grassblade_iframe').height(1000);
         }

         window.clearInterval(intervalID);
      }
    }, 250);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/iframe.js